import { OnlineStatusProps } from "./types"
import React, { useSyncExternalStore } from "react"
import { autorun } from "mobx"
import { useStores } from "~models"
import { useTheme } from '~/ui/styled'
import { formatOnlineDate, decorateOnlinePresenceLine } from "~utils/date"
import styled from '~/ui/styled'

const Text = styled.Text<{ color?: string }>`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({theme, color}) => color || theme.colors.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`

const Online = () => {
  const theme = useTheme()
  return <Text color={theme.colors.success}>在线</Text>
}

/** 最近活跃：规则 2 仅展示格式化时间词，不追加「在线」；规则 1 离线时对「今天 HH:mm」等补后缀 */
const LastSeen = ({
  last_seen,
  recentOnlyRule,
}: {
  last_seen: OnlineStatusProps["last_seen"]
  recentOnlyRule: boolean
}) => {
  const formatted = formatOnlineDate(last_seen)
  if (!formatted) return null
  const text = recentOnlyRule ? formatted : decorateOnlinePresenceLine(formatted)
  return <Text>{text}</Text>
}

function subscribePresenceDisplay(
  walletStore: { show_online_status?: boolean | null; online_display_rule?: number | null },
  onStoreChange: () => void,
) {
  const disposer = autorun(() => {
    void walletStore.show_online_status
    void walletStore.online_display_rule
    onStoreChange()
  })
  return () => disposer()
}

function presenceSnapshot(walletStore: { show_online_status?: boolean | null; online_display_rule?: number | null }) {
  return `${!!walletStore?.show_online_status}:${walletStore?.online_display_rule ?? "nil"}`
}

// 不使用 observer(memo)：在部分 RN / NOBRIDGE 环境下会触发「Component is not a function」
export default function OnlineStatus({ online, last_seen }: OnlineStatusProps) {
  const { walletStore } = useStores()
  useSyncExternalStore(
    (onStoreChange) => subscribePresenceDisplay(walletStore, onStoreChange),
    () => presenceSnapshot(walletStore),
    () => presenceSnapshot(walletStore),
  )
  // 是否展示由“对方”的设置决定（服务端已据此下发 online/last_seen），不再用当前用户自己的开关
  /** 2=仅最近活跃；缺省或非 2 视为实时在线规则（与接口一致） */
  const recentOnlyRule = walletStore.online_display_rule === 2

  if (recentOnlyRule) return <LastSeen last_seen={last_seen} recentOnlyRule={true} />
  return online ? <Online /> : <LastSeen last_seen={last_seen} recentOnlyRule={false} />
}
